/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sales_Order_TotalsInputs */

const en_nav_sales_order_totals = /** @type {(inputs: Nav_Sales_Order_TotalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders by season`)
};

/**
* | output |
* | --- |
* | "Orders by season" |
*
* @param {Nav_Sales_Order_TotalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_sales_order_totals = /** @type {((inputs?: Nav_Sales_Order_TotalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sales_Order_TotalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_sales_order_totals(inputs)
});